import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { type MantineSize, Box, Group, Text } from '@mantine/core'
import { memo } from 'react'

import { Icon } from '../../../Icon/Icon'

type MultiSelectOptionProps = {
  option: {
    badgeSize?: MantineSize
    badgeColor?: string
    checked?: boolean
    label: string
    value: string
  }
}

export const MultiSelectOption = memo(
  ({
    option: { label, badgeColor, badgeSize = 'sm', checked },
  }: Readonly<MultiSelectOptionProps>) => {
    return (
      <Group
        gap='sm'
        data-testid='multiselect-option'
        style={{
          display: 'flex',
          width: '100%',
        }}
      >
        {badgeColor && (
          <Box
            bg={badgeColor}
            style={{ borderRadius: '50%' }}
            h={badgeSize}
            w={badgeSize}
            data-testid='badge'
          />
        )}
        <Text data-testid='multiselect-option-label'>{label}</Text>
        {checked && (
          <Icon
            icon={faCheck}
            size='sm'
            color='green'
            data-testid='checked-icon'
            style={{ marginLeft: 'auto' }}
          />
        )}
      </Group>
    )
  }
)

MultiSelectOption.displayName = 'MultiSelectOption'
